<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  NATURAL_GRAPHITE,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_NATURAL_GRAPHITE,
} from '~/constants/services/constants'
import naturalGraphiteData from '~/constants/price-assessments/unauthorized/natural-graphite'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
    Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })
const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_NATURAL_GRAPHITE
const data = {
  product: NATURAL_GRAPHITE,
  productData: naturalGraphiteData,
  subscription,
}

/*-------------------------------------
    SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${NATURAL_GRAPHITE.name} Prices`,
})
useHead(seo)
</script>
